// eslint-disable-next-line import/no-unresolved,import/no-unassigned-import
import * as React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import { createRoot } from 'react-dom/client';

import { Log } from '@x_x_x/utils';

import { IConfig, DEFAULT_CONFIG, setConfig } from '@constants';

import { HttpTransportBrowser } from '@utils/web';

import { getStore } from '@redux';

import { Api } from '@api';

import { App } from '../../App';
import { getRouter } from '../../Router';

// eslint-disable-next-line import/no-unassigned-import
import '../../styles/common.scss';

const store = getStore();
const root = createRoot(document.getElementById('root'));
let CONFIG: IConfig = DEFAULT_CONFIG;

try {
	CONFIG = JSON.parse(document.getElementById('app-config').innerHTML) as IConfig;

	// eslint-disable-next-line camelcase
	__webpack_require__.p = `${CONFIG.hosts.static}/`;

	setConfig(CONFIG);
} catch (err) {
	Log.error('FAILED PARSE APP CONFIG');
}

// setRoutes(routes);

HttpTransportBrowser.setup();
Api.setTransport(HttpTransportBrowser);

const renderApp = async () => {
	const { Router } = await getRouter();

	root.render(
		<Provider store={store}>
			<BrowserRouter>
				<App Router={Router}/>
			</BrowserRouter>
		</Provider>,
	);
};

void renderApp();
